import {useQuery} from '@tanstack/react-query';
import {getLocalStorage} from '@/Utils/CommonUtils';
import useChatRestClient from '@/Api/ChatRestClient';

interface FeedbackStepRating {
  step: 'RATING';
  question: string;
  max_rating: number;
}

interface FeedbackReason {
  id: number;
  label: string;
}

interface FeedbackStepImprovements {
  step: 'IMPROVEMENTS';
  reasons: FeedbackReason[];
  comment_allowed: boolean;
  comment_max_length: number;
}

interface FeedbackStepMessage {
  step: 'THANK_YOU' | 'COMPLETED';
  message: string;
}

export type FeedbackStep =
  | FeedbackStepRating
  | FeedbackStepImprovements
  | FeedbackStepMessage;

interface FeedbackFormResponse {
  steps: FeedbackStep[];
}

export default function useGetStudentClassFeedbackForm(
  classType?: string,
  studentId?: number,
  webinarId?: number,
) {
  const ChatRestClient = useChatRestClient();
  const normalizedClassType = (classType || '').trim().toLowerCase();
  const queryKey = [
    'student-class-feedback-form',
    normalizedClassType,
    studentId,
    webinarId,
  ];

  return useQuery<FeedbackFormResponse, Error>(
    queryKey,
    async () => {
      const token = await getLocalStorage('access_token');

      const options: any = {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
        },
      };

      let url = `tournament/v1/get_student_class_feedback_form?class_type=${encodeURIComponent(normalizedClassType)}`;
      if (studentId) url += `&student_id=${studentId}`;
      if (webinarId) url += `&webinar_id=${webinarId}`;

      return ChatRestClient.get(url, options);
    },
    {
      enabled: !!webinarId,
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
      retry: 1,
      onError: error => {
        console.error('Failed to fetch feedback form:', error);
      },
    },
  );
}
